export default __webpack_public_path__ + "static/media/fonts/full.22e2d354.svg";